import React, {useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Button, Card, Switch, Typography} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {currencySymbol, getMediaURL, price, showSimpleDate, truncate} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import MakeDiscountCodeButton from "../MakeCharityButton";
import Box from '@mui/material/Box';
import {
    Trash,
    TicketPercent,
    SquareX,
    SquareCheckBig,
    BriefcaseBusiness,
    UserRound,
    Wallet,
    ChevronRight, PanelTopIcon, PanelTopOpen
} from "lucide-react";
import MakeCharityButton from "../MakeCharityButton";
import {Link} from "react-router-dom";

function CharityCard({classes,item,reload}){
    const { t } = useTranslation();
    const loginToken = localStorage.getItem('ACT');
    const [loading, setLoading] = useState(false);

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const handleDelete = (item_id) =>{
        setLoading(true);
        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/charities/delete`,data,config)
            .then(response => {
                setLoading(false);
                reload();

            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    const handleActive = (item_id) =>{

        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/charities/toggle-active`,data,config)
            .then(response => {
                reload();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);

            });
    }
    return (
        <Card className="item-card bg-card">
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Box>
                        <div className="flex-justify-center d-flex align-center flex-column">
                                <img className="charity-logo" src={getMediaURL(item.file,'small')} alt={item.name}/>
                                <Typography align="center" className="bold my-10">
                                    {item.name}
                                </Typography>

                        </div>
                        <div className="charity-status">
                            {
                                !!item.active ?
                                    <Typography className="table-badge active">{t('active')}</Typography>
                                    :
                                    <Typography className="table-badge inactive">{t('inactive')}</Typography>
                            }
                        </div>
                    </Box>
                    <Box className="charity-info">
                        <div className="flex-direction mb-5">
                            <BriefcaseBusiness className="lucide-small-narrow"/>
                            <span>{item.activity_field}</span>
                        </div>
                        <div className="flex-direction mb-5">
                            <UserRound  className="lucide-small-narrow"/>
                            <span><Link to={`/panel/manage/users/edit/${item.user?.id}`}>{item.user?.first_name} {item.user?.last_name}</Link></span>
                            <ChevronRight  className="lucide-small-narrow"/>
                        </div>
                        <div className="flex-direction mb-5">
                            <Wallet  className="lucide-small-narrow"/>
                            <span>{price(item.user?.wallet?.amount)} {currencySymbol}</span>
                        </div>
                        {/*<div className="flex-direction my-5">
                            <PanelTopOpen  className="lucide-icon-primary lucide-small-narrow"/>
                            <Button
                                size="small"
                                className="p-0"
                            >
                               Donates: 122222 tl (1)
                            </Button>
                        </div>*/}
                        <div className="mb-10">
                            <span className="charity-desc">{truncate(item.description,35)}</span>
                        </div>
                    </Box>
                    <div>
                        <div className="actions actions-gap action-holder p-less">
                            <div className="flex-direction" style={{gap: 3}} >
                                <GetConfirmationButton
                                    handleAction={() => handleDelete(item.id)}
                                    question={t('doYouWanaDeleteItem')}
                                    icon={<CheckBoxRounded/>}
                                    tooltip={t('delete')}
                                    loading={loading}
                                    iconColor="primary"
                                >
                                    <Trash className="lucide-icon-primary btn"/>
                                </GetConfirmationButton>
                                <Switch
                                    size="small"
                                    checked={item.active}
                                    onChange={() => handleActive(item.id)}
                                    color="secondary"
                                />
                            </div>
                            <MakeCharityButton item_id={item.id} reload={reload}/>
                        </div>
                    </div>

                </Grid>
            </Grid>
        </Card>
    );
}
export default withStyles(Styles)(CharityCard);
